import React from 'react';
import { useSelector } from 'react-redux';

// Types
import { GoalItem } from 'Shared/constants/types';

// Selectors
import * as UsersSelectors from 'Shared/selectors/Users.selectors';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './GoalDepartment.scss';

type Props = {
  goal: GoalItem;
};

const GoalDepartment = ({ goal }: Props) => {
  const baseClassName = 'GoalDepartment';

  const assigneeId = goal.assigneeId;
  const assigneeUser = useSelector(state => UsersSelectors.getUserByUserId(state, { userId: assigneeId }))?.toJS();
  const department = assigneeUser?.department;

  if (!department) return null;

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__icon`}>
        <WpIcon name="building" size="sm" />
      </div>
      {department}
    </div>
  );
};

export default GoalDepartment;
